import { Resource } from '@redge-media/fo-js-sdk';

const Badges = Resource.extend({
  endpoint: '/badges',
});

export default Badges;
